const { randomExcept } = require('../../Number/utils/randomExcept')

/**
 * Véletlenszerűen kiválasztott elemek egy tömbből.
 * @template T
 * @param {ReadonlyArray<T>} array         - A tömbbünk.
 * @param {number}           count         - Hány elemet kérünk.
 * @param {ReadonlyArray<T>} except        - Kivéve.
 * @param {boolean}          isConsecutive - Növekvő sorrend.
 * @returns {Array<T>} A kiválasztott elemek.
 */
module.exports.samples = function samples (array, count = 1, except = [], isConsecutive = false) {
  const filteredArray = array.filter((item) => {
    return except.every((exceptItem) => exceptItem !== item)
  })

  // TODO: A következő sorok 1:1-ben a régi Array.randomUniqNumbers kódja. (mostani @apps/gameLogics/math/randomUniqNumbers)
  // Ezt kell majd óvatosan refaktorálni, de a samples millió helyen van használva, óvatosan!
  // Először sokkal több tesztel kell lefedni ezt a függvényt.
  const maxCount = filteredArray.length

  const validCount = Math.min(maxCount, count)

  /** @type {Array<number>} */
  const randIndexes = Array.from({ length: validCount }).reduce((acc) => {
    const random = randomExcept(0, filteredArray.length - 1, acc)

    return [ ...acc, random ]
  }, [])

  // TODO: IDÁIG

  if (isConsecutive) {
    // eslint-disable-next-line no-restricted-syntax
    randIndexes.sort((/** @type { number} */ a, /** @type { number} */ b) => (a - b))
  }

  return randIndexes.map((index) => filteredArray[index])
}
